import { useOutletContext } from "react-router-dom";
import Services from "../components/landing/Services";

export default function ServicesPage() {
  const content = useOutletContext();
  return <Services services={content.services} settings={content.settings} />;
}
